import { Component } from '@angular/core';
import { DadosProvider } from '../../providers/dados/dados';

@Component({
  selector: 'page-contato',
  templateUrl: 'contato.html',
})
export class ContatoPage {
  configuracao:any = {};

  constructor(dadosProdider:DadosProvider) {
    if(dadosProdider.configuracao) this.configuracao = dadosProdider.configuracao;
  }

  abrirTelefone(telefone){
    // this.dados
  }

  removerCaracteres(texto){
    return texto.replace(/\D/g, "");
  }
}



// WEBPACK FOOTER //
// ./src/pages/contato/contato.ts